import InputSlider from '@/components/sections/builder/settings/input-slider';
import { ThemeInputType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_INPUT = {
  borderThickness: 1,
  borderOpacity: 100,
  borderCornerRadius: 4,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 4,
  shadowBlur: 5,
};

export default function ThemeInputSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const input = builder.theme?.input || DEFAULT_THEME_INPUT;

  const setLayout = (newInput: Partial<ThemeInputType>) => {
    builder.setTheme({
      input: { ...input, ...newInput },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={input.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setLayout({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={input.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={input.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setLayout({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <InputSlider
        label='Opacity'
        value={input.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={input.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={input.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={input.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setLayout({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
    </div>
  );
}
